/*
  This component renders an author with a responsive layout.

  It includes an image,
  primary content (name, followers count, books count, follow button),
  and optional secondary content (expandable description)).
*/

import AuthorBadge from "./author_badge";
import AuthorFollowButton from "./author_follow_button";
import AuthorFollowCount from "./author_follow_count";
import ExpandableHtml from "../user_content/expandable_html";
import GrPropTypes from "../shared/gr_prop_types";
import { PropTypes } from "react";

const ResponsiveAuthor = ({ author, includeBestBook, includeDescription }) => {

  const authorWorks = (
    <div className="responsiveAuthor__authorWorks">
      Author of <a className="gr-hyperlink"
                   href={author.worksListUrl}
                   itemProp="url">
                   {author.worksCount} books
                </a>
      { includeBestBook && author.bestBook &&
        <span> including <a className="gr-hyperlink"
                           href={author.bestBook.bookUrl}
                           itemProp="url">
                           {author.bestBook.bookTitleBare}
                         </a>
        </span>
      }
    </div>
  );

  const primary = (
    <div className="objectLockupPrimaryContent--grid u-paddingTopTiny">
      <div className="objectLockupPrimaryContent__main">
        <a className="gr-h3 gr-h3--serif gr-h3--noMargin"
           href={author.profileUrl}
           itemProp="url">
          <span itemProp="name">{author.name}</span>
        </a>
        <AuthorBadge isGoodreadsAuthor={author.isGoodreadsAuthor} size={AuthorBadge.AUTHOR_BADGE_SIZES.LARGE} />
        <div className="responsiveAuthor__followCount">
          <AuthorFollowCount authorId={author.id} />
        </div>
        {authorWorks}
      </div>
      <div className="objectLockupPrimaryContent__bottomToRight">
        <AuthorFollowButton authorId={author.id} />
      </div>
    </div>
  );

  const secondary = (
    <div className="u-marginTopMedium">
      <ExpandableHtml {...author.description} />
    </div>
  );

  return(
    <div className="responsiveAuthor"
         itemScope itemType="http://schema.org/Person">

      <div className="objectLockupContent">
        <div className="objectLockupContent__media">
          <div className="responsiveAuthor__media">
            <a href={author.profileUrl}>
              <img src={author.profileImage}
                   alt={author.name}
                   className="responsiveAuthor__img"
                   itemProp="image" />
            </a>
          </div>
        </div>
        {primary}
        { includeDescription && author.description &&
          <div className="objectLockupContent__secondary">
            {secondary}
          </div>
        }
      </div>
    </div>
  );
};

ResponsiveAuthor.propTypes = {
  author: GrPropTypes.author({
    bestBook: GrPropTypes.book().isRequired,
    followersCount: PropTypes.number.isRequired,
    worksCount: PropTypes.number.isRequired,
    worksListUrl: PropTypes.string.isRequired,
  }).isRequired,
  includeBestBook: PropTypes.bool,
  includeDescription: PropTypes.bool,
};

export default ResponsiveAuthor;
